import { Injectable } from '@angular/core';
import { CallHttpService } from './call-http.service';

import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AdministratorEntity } from '../model/AdministratorEntity';

@Injectable({
  providedIn: 'root'
})
export class AdministrationService {

  constructor(private callHttpService: CallHttpService) { }
  sendRequest(entity:AdministratorEntity):Observable<any>{
    let service = entity.type;
    return this.callHttpService.post(`${environment.apiAdministration}/${service}`,entity);
  }

}
